export const ledgerNotesHeaders = [
  {
    text: "Date",
    value: "created_at"
  },
  {
    text: "Source",
    value: "author"
  },
  {
    text: "Note",
    value: "description"
  },
  {
    text: "Title",
    value: "title"
  }
];
